/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Utils component
import TextError from "utils/TextError";

// Dashboard components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDCard from "components/MDCard";

// Dashboard example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// React-Select component and styling
import Select from "react-select";
import "../../index.css";

// Functions from store
import {
  createUser,
  deleteUser,
  editUser,
  getReportedTickets,
  getUser,
  getClients,
} from "../../store";
import Config from "../../config/index";

// Cookies
import Cookies from "universal-cookie";
import { Backdrop, CircularProgress } from "@mui/material";
const cookies = new Cookies();

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  color: "black",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const Users = ({
  getReportedTickets,
  deleteUser,
  createUser,
  getUser,
  editUser,
  reportedTicketsReducer,
  userReducer,
  getClients,
  getClientsReducer,
  //  getRequestTypes
}) => {
  let userData = cookies.get("loginDetailsForSupport");
  let clientId = userData?.data?.clientId;
  let userId = userData?.data?.userId;
  let productId = userData?.data?.productId;
  let role = userData?.data?.role;

  let supportIssuesPayload = Config.supportIssuesPayload;
  let token = userData?.token;

  let payload = {
    data: {
      reporterEmailId: userData.data.email,
      projectId: supportIssuesPayload.projectId,
    },
    email: userData.data.email,
    token: token,
  };

  useEffect(() => {
    getReportedTickets(payload.data, token);
  }, []);

  const [clientIdSelected, setClientIdSelected] = useState("");
  const [clientIdSelectedFC, setClientIdSelectedFC] = useState("");

  useEffect(() => {
    if (role === "ADMIN") {
      getUser(clientId, token);
    }
    if (role === "EXECUTIVE") {
      getUser(clientIdSelected.value, token);
    }
  }, [clientIdSelected]);

  useEffect(() => {
    getClients(token);
  }, []);

  const [clientsForFilterOptions, setclientsForFilterOptions] = useState([]);

  useEffect(() => {
    let tempRequests = [];

    let data = getClientsReducer.clients ? getClientsReducer.clients : [];

    data.map((request) => {
      const requestObject = {
        label: request.companyName,
        value: request.clientId,
      };

      tempRequests.push(requestObject);
    });
    setclientsForFilterOptions(tempRequests);
  }, [getClientsReducer]);

  useEffect(() => {
    setClientIdSelected({
      label: getClientsReducer?.clients[0]?.companyName,
      value: getClientsReducer?.clients[0]?.clientId,
    });
  }, [getClientsReducer]);

  const changeClient = (selectedOption) => {
    setClientIdSelected(selectedOption);
  };
  const changeClientFC = (selectedOption) => {
    setClientIdSelectedFC(selectedOption);
  };

  const [state, setState] = useState({
    columns: [
      { Header: "Name", accessor: "name", align: "left" },
      { Header: "Email", accessor: "email", align: "left" },
      { Header: "role", accessor: "role", align: "left" },
      { Header: "Phone", accessor: "phone", align: "left" },
      { Header: "Action", accessor: "action", align: "center" },
    ],
    rows: [],
  });

  const [singleUserForUpdate, setSingleUserForUpdate] = useState({});

  const initialValueForUpdate = {
    name: singleUserForUpdate.name,
    email: singleUserForUpdate.email,
    phoneNumber: singleUserForUpdate.contactNo,
  };

  const [openUpdateUserModal, setOpenUpdateUserModal] = useState(false);
  const handleOpenUpdateUserModal = (issue) => {
    setSingleUserForUpdate(issue);
    setOpenUpdateUserModal(true);
    // formikForUpdate.setValues(initialValueForUpdate);
    formikForUpdate.setTouched({});
    formikForUpdate.setErrors({});
  };

  const handleCloseUserModal = () => {
    setOpenUpdateUserModal(false);
    formikForUpdate.setErrors({});
    formikForUpdate.setValues(initialValueForUpdate);
  };

  const [errorMsgForDelete, setErrorMsgForDelete] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [singleUserDataForDelete, setSingleUserDataForDelete] = useState({});

  const handleOpenDeleteModal = (asset = {}) => {
    setSingleUserDataForDelete(asset);
    setOpenDeleteModal(true);
  };
  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };
  const [isErrorDelete, setIsErrorDelete] = useState(false);
  const [isSuccessDelete, setIsSuccessDelete] = useState(false);

  useEffect(() => {
    if (isErrorDelete) {
      setTimeout(() => {
        setIsErrorDelete(false);
      }, 3000);
    }
  }, [isErrorDelete]);

  useEffect(() => {
    if (isSuccessDelete) {
      setTimeout(() => {
        setIsSuccessDelete(false);
      }, 3000);
    }
  }, [isSuccessDelete]);

  const { columns, rows } = state;
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let tempIssues = [];
    let issuesData = userReducer.users ? userReducer.users : [];
    setLoading(userReducer.loading);
    issuesData.map((issue) => {
      const singleIssue = {
        privateKey: issue.id,
        key: issue.key,
        name: issue.name,
        email: issue.email,
        role: issue.role,
       phone: issue.contactNo,
action: (
  <div>
    <Tooltip title="Edit ">
      <MDButton
        variant="gradient"
        color="success"
        iconOnly
        type="button"
        disabled={issue.role?.toUpperCase() === "ADMIN"}
        onClick={() => handleOpenUpdateUserModal(issue)}
        style={{ marginRight: "5px" }}
      >
        <Icon>edit_sharp</Icon>
      </MDButton>
    </Tooltip>

    <Tooltip title="Delete">
      <MDButton
        variant="gradient"
        color="error"
        iconOnly
        type="button"
        disabled={issue.role?.toUpperCase() === "ADMIN"}
        style={{ marginRight: "5px" }}
        onClick={() => handleOpenDeleteModal(issue)}
      >
        <Icon>delete</Icon>
      </MDButton>
    </Tooltip>
  </div>
),
      };
      tempIssues.push(singleIssue);
    });
    setState({ ...state, rows: tempIssues });
  }, [userReducer]);

  const [isSuccessCreateUser, setIsSuccessCreateUser] = useState(false);
  const [isErrorCreateUser, setIsErrorCreateUser] = useState(false);  
  const [errorMsgForCreate, setErrorMsgForCreate] = useState(false);

  useEffect(() => {
    if (isErrorCreateUser) {
      setTimeout(() => {
        setIsErrorCreateUser(false);
      }, 3000);
    }
  }, [isErrorCreateUser]);

  useEffect(() => {
    if (isSuccessCreateUser) {
      setTimeout(() => {
        setIsSuccessCreateUser(false);
      }, 3000);
    }
  }, [isSuccessCreateUser]);

  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");

const onSubmitForUpdate = async (values) => {
  let payload = {
    name: values.name,
    email: values.email,
    userId: singleUserForUpdate.userId,
    role: singleUserForUpdate.role,
    contactNo: values.phoneNumber,
  };

  let res = await editUser(payload, token);

  if (res.status) {
    setIsSuccessForUpdate(true);

    // ✅ Corrected getUser call
    if (role === "ADMIN") {
      getUser(clientId, token);
    } else if (role === "EXECUTIVE") {
      getUser(clientIdSelected?.value, token);
    }
  }

  if (!res.status) {
    setIsErrorForUpdate(true);
    setErrorMsgForUpdate(res.data.data.message);
  }
};
  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    // validationSchema: validationSchemaForUpdate,
    enableReinitialize: true,
  });

  const [createUserModal, setCreateUserModal] = useState(false);

  const handleCreateUser = () => {
    setCreateUserModal(!createUserModal); 
    setClientIdSelectedFC("")
    formikForCreateUser.setValues(initialValueForCreateUser);
    formikForCreateUser.setTouched({});
    formikForCreateUser.setErrors({});
  };

  const initialValueForCreateUser = {
    name: "",
    email: "",
    password: "",
    phoneNumber: "",
    confirmPassword: "",
  };

const onSubmitForCreateUser = async (values, { resetForm }) => {
  let payload = {
    name: values.name,
    email: values.email,
    password: values.password,
    contactNo: values.phoneNumber,
    confirmPassword: values.confirmPassword,
   clientId:
    role === "ADMIN"
      ? clientId
      : clientIdSelectedFC?.value ,
    productId: productId,
  };

  let res = await createUser(payload, token);

  if (res.status) {

    if (role === "ADMIN") {
      getUser(clientId, token);
    }

    if (role === "EXECUTIVE") {
      getUser(clientIdSelected?.value, token);
    }

    setIsSuccessCreateUser(true);
    resetForm();
  }

  if (!res.status) {
    setIsErrorCreateUser(true);
    setErrorMsgForCreate(res.response.message);
  }
};
  const deleteUserData = async () => {
    let userId = singleUserDataForDelete.userId;
    let response = await deleteUser(userId, token);
    if (response.status) {
      setIsSuccessDelete(true);
      getUser(token);

      setTimeout(() => {
        handleCloseDeleteModal();
      }, 2250);
    }
    if (!response.status) {
      setIsErrorDelete(true);
      setErrorMsgForDelete(response.data.data.message);
    }
  };

  const validationSchemaForCreateUser = Yup.object({
    name: Yup.string().required("Enter a Name"),
    email: Yup.string().required("Enter a Email"),
    password: Yup.string()
      .required("Enter the password!")
      .matches(
        /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
        "Password must be min 8 characters, and have 1 Special Character, 1 Uppercase, 1 Number and 1 Lowercase"
      ),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Confirm Password is not matching")
      .required("Confirm Password is required"),

    phoneNumber: Yup.string()
      .required("Enter Contact Number!")
      .matches(/^[0-9]{10}$/, "Contact number must be exactly 10 digits"),
  });

  const formikForCreateUser = useFormik({
    initialValues: initialValueForCreateUser,
    validationSchema: validationSchemaForCreateUser,
    onSubmit: onSubmitForCreateUser,
  });

  return (
    <div>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={0} pb={3}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox display="flex" p={3} mt={-1}>
                  <Tooltip title="Create User">
                    <MDButton
                      iconOnly
                      color="info"
                      type="button"
                      onClick={handleCreateUser}
                    >
                      <Icon>add</Icon>
                    </MDButton>
                  </Tooltip>
                  {role === "EXECUTIVE" && (
                    <MDBox
                      style={{
                        marginLeft: "2rem",
                      }}
                    >
                      <Select
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            borderRadius: 5,
                            height: "12px",
                            width: "15rem",
                          }),
                        }}
                        className="select-css"
                        placeholder="Choose one..."
                        name="Clients"
                        options={clientsForFilterOptions}
                        onChange={changeClient}
                        value={clientIdSelected}
                      />
                    </MDBox>
                  )}
                </MDBox>

                <MDBox mt={-2}>
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={true}
                    canSearch={true}
                    entriesPerPage={{
                      defaultValue: 5,
                      entries: [5, 10, 15, 20, 25, 30],
                    }}
                    showTotalEntries={true}
                    noEndBorder
                  />
                </MDBox>

                <Modal
                  open={createUserModal}
                  onClose={handleCreateUser}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDCard sx={style}>
                    <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                      <MDTypography
                        variant="h4"
                        fontWeight="medium"
                        flexGrow={1}
                      >
                        Create User
                      </MDTypography>
                      <MDBox>
                        <Tooltip title="Close">
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            onClick={handleCreateUser}
                            style={{
                              background: "whitesmoke",
                              color: "black",
                              borderRadius: 5,
                              marginLeft: "-55px",
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                      </MDBox>
                    </MDBox>
                    <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                    <MDBox pt={1} pb={3} px={3}>
                      <MDBox
                        component="form"
                        role="form"
                        onSubmit={formikForCreateUser.handleSubmit}
                      >
                           {/* <Grid item xs={6}> */}
                                             {role !== "ADMIN" && (
  <MDBox mb={2}>
    <MDTypography variant="h6">
      Client
    </MDTypography>
    <Select
      className="select-css"
      placeholder="Choose one..."
      name="Client"
      options={clientsForFilterOptions}
      value={clientIdSelectedFC}
      onChange={(selectedOption) => {
        changeClientFC(selectedOption);
      }}
    />
    {formikForCreateUser.errors.Client && (
      <TextError msg={formikForCreateUser.errors.Client} />
    )}
  </MDBox>
)}
                                                {/* </Grid> */}
                        <MDBox mb={2}>
                          <MDTypography variant="h6">Name</MDTypography>
                          <MDInput
                            type="text"
                            name="name"
                            fullWidth
                            autoComplete="off"
                            onBlur={formikForCreateUser.handleBlur}
                            onChange={formikForCreateUser.handleChange}
                            value={formikForCreateUser.values.name}
                            error={
                              formikForCreateUser.touched.name &&
                              formikForCreateUser.errors.name &&
                              true
                            }
                            inputProps={{
                              maxLength: 45,
                            }}
                          />
                          {formikForCreateUser.touched.name &&
                            formikForCreateUser.errors.name && (
                              <TextError
                                msg={formikForCreateUser.errors.name}
                              />
                            )}
                        </MDBox>

                  <MDBox mt={2}>
  <MDTypography
    variant="h6"
    style={{ fontWeight: 500 }}
  >
    Email
  </MDTypography>

  <MDInput
    type="email"
    name="email"
    fullWidth
    autoComplete="new-email"
    inputProps={{ autoComplete: "new-password" }}
    onChange={formikForCreateUser.handleChange}
    onBlur={formikForCreateUser.handleBlur}
    value={formikForCreateUser.values.email}
    error={
      formikForCreateUser.touched.email &&
      formikForCreateUser.errors.email &&
      true
    }
  />

  {formikForCreateUser.touched.email &&
    formikForCreateUser.errors.email && (
      <TextError
        msg={formikForCreateUser.errors.email}
      />
  )}
</MDBox>

                        <MDBox mt={2}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: 500 }}
                          >
                            Phone Number
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="phoneNumber"
                            fullWidth
                            autoComplete="off"
                            onChange={formikForCreateUser.handleChange}
                            onBlur={formikForCreateUser.handleBlur}
                            value={formikForCreateUser.values.phoneNumber}
                            error={
                              formikForCreateUser.touched.phoneNumber &&
                              formikForCreateUser.errors.phoneNumber &&
                              true
                            }
                          />
                          {formikForCreateUser.touched.phoneNumber &&
                            formikForCreateUser.errors.phoneNumber && (
                              <TextError
                                msg={formikForCreateUser.errors.phoneNumber}
                              />
                            )}
                        </MDBox>
                        <MDBox mt={2}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: 500 }}
                          >
                            Password
                          </MDTypography>
                          <MDInput
                            type="password"
                            name="password"
                            fullWidth
                            autoComplete="off"
                            onChange={formikForCreateUser.handleChange}
                            onBlur={formikForCreateUser.handleBlur}
                            value={formikForCreateUser.values.password}
                            error={
                              formikForCreateUser.touched.password &&
                              formikForCreateUser.errors.password &&
                              true
                            }
                          />
                          {formikForCreateUser.touched.password &&
                            formikForCreateUser.errors.password && (
                              <TextError
                                msg={formikForCreateUser.errors.password}
                              />
                            )}
                        </MDBox>
                        <MDBox mt={2}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: 500 }}
                          >
                            Confirm Password
                          </MDTypography>
                          <MDInput
                            type="password"
                            name="confirmPassword"
                            fullWidth
                            autoComplete="off"
                            onChange={formikForCreateUser.handleChange}
                            onBlur={formikForCreateUser.handleBlur}
                            value={formikForCreateUser.values.confirmPassword}
                            error={
                              formikForCreateUser.touched.confirmPassword &&
                              formikForCreateUser.errors.confirmPassword &&
                              true
                            }
                          />
                          {formikForCreateUser.touched.confirmPassword &&
                            formikForCreateUser.errors.confirmPassword && (
                              <TextError
                                msg={formikForCreateUser.errors.confirmPassword}
                              />
                            )}
                        </MDBox>

                        <MDBox>
                          <Collapse in={isErrorCreateUser}>
                            <Alert
                              severity="error"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsErrorCreateUser(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              {errorMsgForCreate}
                            </Alert>
                          </Collapse>
                          <Collapse in={isSuccessCreateUser}>
                            <Alert
                              severity="success"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsSuccessCreateUser(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              User created successfully
                            </Alert>
                          </Collapse>
                        </MDBox>
                        <MDBox mt={3}>
                          <MDButton
                            variant="contained"
                            color="info"
                            fullWidth
                            type="submit"
                            disabled={!formikForCreateUser.isValid}
                          >
                            Create
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDCard>
                </Modal>
                <Modal
                  open={openUpdateUserModal}
                  onClose={handleCloseUserModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDCard sx={style}>
                    <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                      <MDTypography
                        variant="h4"
                        fontWeight="medium"
                        flexGrow={1}
                      >
                        Update
                      </MDTypography>
                      <MDBox>
                        <Tooltip title="Close">
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            onClick={handleCloseUserModal}
                            style={{
                              background: "whitesmoke",
                              color: "black",
                              borderRadius: 5,
                              marginLeft: "-55px",
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                      </MDBox>
                    </MDBox>
                    <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                    <MDBox pt={1} pb={3} px={3}>
                      <MDBox
                        component="form"
                        role="form"
                        onSubmit={formikForUpdate.handleSubmit}
                      >
                        <MDBox mb={2}>
                          <MDTypography variant="h6">Name</MDTypography>
                          <MDInput
                            type="text"
                            name="name"
                            fullWidth
                            autoComplete="off"
                            onBlur={formikForUpdate.handleBlur}
                            onChange={formikForUpdate.handleChange}
                            value={formikForUpdate.values.name}
                            error={
                              formikForUpdate.touched.name &&
                              formikForUpdate.errors.name &&
                              true
                            }
                            inputProps={{
                              maxLength: 45,
                            }}
                          />
                          {formikForUpdate.touched.name &&
                            formikForUpdate.errors.name && (
                              <TextError msg={formikForUpdate.errors.name} />
                            )}
                        </MDBox>
                        <MDBox mb={2}>
                          <MDTypography variant="h6">Email</MDTypography>
                          <MDInput
                            type="text"
                            name="email"
                            fullWidth
                            autoComplete="off"
                            onBlur={formikForUpdate.handleBlur}
                            onChange={formikForUpdate.handleChange}
                            value={formikForUpdate.values.email}
                            error={
                              formikForUpdate.touched.email &&
                              formikForUpdate.errors.email &&
                              true
                            }
                            inputProps={{
                              maxLength: 45,
                            }}
                          />
                          {formikForUpdate.touched.email &&
                            formikForUpdate.errors.email && (
                              <TextError msg={formikForUpdate.errors.email} />
                            )}
                        </MDBox>

                        <MDBox mt={2}>
                          <MDTypography variant="h6">Phone Number</MDTypography>
                          <MDInput
                            type="text"
                            name="phoneNumber"
                            fullWidth
                            autoComplete="off"
                            onBlur={formikForUpdate.handleBlur}
                            onChange={formikForUpdate.handleChange}
                            value={formikForUpdate.values.phoneNumber}
                            error={
                              formikForUpdate.touched.phoneNumber &&
                              formikForUpdate.errors.phoneNumber &&
                              true
                            }
                            inputProps={{
                              maxLength: 45,
                            }}
                          />
                          {formikForUpdate.touched.phoneNumber &&
                            formikForUpdate.errors.phoneNumber && (
                              <TextError msg={formikForUpdate.errors.email} />
                            )}
                        </MDBox>

                        <MDBox>
                          <Collapse in={isErrorForUpdate}>
                            <Alert
                              severity="error"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsErrorForUpdate(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              {errorMsgForUpdate}
                            </Alert>
                          </Collapse>
                          <Collapse in={isSuccessForUpdate}>
                            <Alert
                              severity="success"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsErrorForUpdate(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              Users updated successfully
                            </Alert>
                          </Collapse>
                        </MDBox>
                        <MDBox mt={3}>
                          <MDButton
                            variant="contained"
                            color="success"
                            fullWidth
                            type="submit"
                            disabled={!formikForUpdate.isValid}
                          >
                            Submit
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDCard>
                </Modal>
                <Modal
                  open={openDeleteModal}
                  onClose={handleCloseDeleteModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDCard sx={deleteStyle}>
                    <MDTypography>
                      Are you sure you want to delete?
                    </MDTypography>
                    <MDBox mt={2} display="flex">
                      <div>
                        <MDButton
                          style={{ width: "100%", marginRight: "0.5rem" }}
                          color="info"
                          variant="outlined"
                          onClick={handleCloseDeleteModal}
                        >
                          Cancel
                        </MDButton>
                      </div>
                      <div style={{ float: "right" }}>
                        <MDButton
                          style={{ width: "100%", marginLeft: "0.5rem" }}
                          color="error"
                          onClick={deleteUserData}
                        >
                          Delete
                        </MDButton>
                      </div>
                    </MDBox>
                    <MDBox mt={2}>
                      <Collapse in={isSuccessDelete}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsSuccessDelete(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          Deleted successfully!
                        </Alert>
                      </Collapse>
                      <Collapse in={isErrorDelete}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorDelete(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {errorMsgForDelete}
                        </Alert>
                      </Collapse>
                    </MDBox>
                  </MDCard>
                </Modal>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        {loading && (
          <Backdrop
            sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
        <Footer />
      </DashboardLayout>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    reportedTicketsReducer: state.reportedTicketsReducer,
    userReducer: state.UserReducer,
    getClientsReducer: state.getClientsReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getReportedTickets: (payload, token) =>
      dispatch(getReportedTickets(payload, token)),
    createUser: (payload, token) => dispatch(createUser(payload, token)),
    deleteUser: (userId, token) => dispatch(deleteUser(userId, token)),
    editUser: (payload, token) => dispatch(editUser(payload, token)),
    getUser: (clientId, token) => dispatch(getUser(clientId, token)),
    getClients: (token) => dispatch(getClients(token)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(Users);
